import {autorun, makeAutoObservable} from "mobx";
import {connection} from "./connection";
import {cubeModel} from "./cube";
import {occupancyModel} from "./occupancy";
import {BoxAvailabilityResponse} from "./types";

class AvailabilityModel {
	availability = new Map<string, BoxAvailabilityResponse[]>();

	constructor() {
		makeAutoObservable(this);
	}

	async fetchAvailability(hostname: string) {
		const boxes = await connection.fetchBoxAvailability(hostname);
		this.availability.set(hostname, boxes);
	}
}

export const availabilityModel = new AvailabilityModel();

// auto fetch box availability for verified cubes
autorun(async () => {
	if (connection.online) {
		for (let cube of cubeModel.cubes) {
			if (!availabilityModel.availability.has(cube.hostname)) {
				await availabilityModel.fetchAvailability(cube.hostname);
			}
		}
	}
});

// auto fetch box availability for occupancies
autorun(async () => {
	if (connection.online) {
		for (let occupancy of occupancyModel.occupancies) {
			if (!availabilityModel.availability.has(occupancy.box.cube.hostname)) {
				await availabilityModel.fetchAvailability(occupancy.box.cube.hostname);
			}
		}
	}
});
